module.exports = __webpack_public_path__ + "img/emerit_watch.10f9a3b0.png";